import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Profile from './UserInfo/Profile';
import UserPayHistory from './UserInfo/UserPayHistory';
import AgencyAdmin from './UserInfo/AgencyAdmin'
import Title from './UserInfo/dev/Title';
import LoadingSpinner from './dev/LoadingSpinner'

const { REACT_APP_URI = '/' } = process.env

class UserInfo extends Component {
    state = {
        userInfo: {},
        companyInfo: {},
        setPasswordActive: '',
        isEdit: false,
        isCompanyEdit: false,
        isMemberEdit: false,
        isCancel: false,
        isContentLoading: false,
        isSuccesstoCancel: false,
        editedUserInfo: {},
        userPayHistory: [],
        nextPayDate: '',
        currentCard:'',
        cancelError:'',
        isUserPayHistoryLoading: true,
    }
    componentDidMount() {
        fetch(`${REACT_APP_URI}/accounts/userInfo/`, { credentials: 'include' })
            .then(res => res.json())
            .then(userInfo => this.setState({userInfo}))
        fetch(`${REACT_APP_URI}/accounts/userPayHistory/`, { credentials: 'include' })
            .then(res => res.json())
            .then(userPayHistory => { 
                const { history, nextPayDate, currentCard,isCancelSubscription } = userPayHistory
                this.setState({ userPayHistory: history, isUserPayHistoryLoading: false, nextPayDate, currentCard,isCancelSubscription })})
    }
    /*此區域內含大量廢物 PM 所寫的 Code，觀賞前請做好心理準備*/
    cancelSubscription = () => {
        const { messages, user: { token } } = this.props
        this.setState({ isContentLoading: true })
        fetch(`${REACT_APP_URI}/accounts/cancelSubscription/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify()
        })
        .then(res => {
            const { status } = res
            if (status === 200) this.setState({cancelError: messages.user_chancel_success, isContentLoading: false, isSuccesstoCancel:true })
            else this.setState({cancelError: messages.payment_unknown_error, isContentLoading: false })
        })
    }
    editUserInfoInput = condition => e => this.setState({ editedUserInfo: { ...this.state.editedUserInfo, [condition]: e.target.value }})
    editUserInfoSubmit = () => {
        const { token } = this.props.user
        const { editedUserInfo } = this.state
        fetch(`${REACT_APP_URI}/accounts/editUserInfo/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ ...editedUserInfo })
        })
        .then(res => {
            const { status } = res
            if (status === 200) { this.setState({ response: '' }, () => window.location.reload())}
        })
    }
    editUserInfoCancel = () => {
        this.toggleEdit(false);
        this.setState({ editedUserInfo: {}})
    }
    toggleEdit = condition => this.setState({ isEdit: condition })
    toggleCancel = () => {
        this.props.history.push('/CancelSubscription')
        window.scrollTo(0, 0);
    }

    renderCancel = (nextPayDate) => {
        const { cancelSubscription, toggleCancel, props: {messages},state: { isCancel,isContentLoading,cancelError,isSuccesstoCancel} } = this
        return (
            <Mask  isActive={isCancel}>
                <MaskContent>
                    <Title>{messages.user_chancel}</Title>
                    <SubTitle padding='50px'>{messages.user_chancel_date}&nbsp;{nextPayDate}&nbsp;{messages.user_chancel_stop_pay}</SubTitle>
                    {isContentLoading && <LoadingSpinner size={'30px'} />}
                    {!isContentLoading && <Error>{cancelError}</Error>}
                    {!isContentLoading && !isSuccesstoCancel && <Footer>
                        <Edit onClick={() => cancelSubscription()}>{messages.user_chancel_confirm}</Edit>
                        <Edit onClick={() => toggleCancel(false)}>{messages.user_chancel_deny}</Edit>
                    </Footer>}
                    {isSuccesstoCancel && <Footer>
                        <Edit onClick={() => window.location.reload()}>{messages.ok}</Edit>
                    </Footer>}
                </MaskContent>
            </Mask>
        )
    }


    render() {
        const { userPayHistory, nextPayDate, currentCard, companyInfo, userInfo: { plan }, isCancelSubscription, isUserPayHistoryLoading } = this.state
        const { messages} = this.props
        const { toggleCancel,renderCancel } = this
        return (
            <Container>
                {renderCancel(nextPayDate)}
                <Profile {...this}/>
                {(plan === 'Agency(Admin)' || plan === 'Agency(Member)') && <AgencyAdmin companyInfo={companyInfo}/>}
                {userPayHistory !== {} && <UserPayHistory userPayHistory={userPayHistory} nextPayDate={nextPayDate} currentCard={currentCard} isCancelSubscription={isCancelSubscription} />}
                {isUserPayHistoryLoading && <LoadingSpinner/>}
                {!isUserPayHistoryLoading && isCancelSubscription !== undefined && (plan === 'Brand'|| plan ==='Creator' || plan ==='Agency(Admin)') && !isCancelSubscription && <CancelButton onClick={() => toggleCancel()}>{messages.user_chancel_confirm}</CancelButton>}
                {/*PM表示只有 Brand、 Creator 以及 Agency(Admin) 方案而且沒停用才會出現停用按鈕*/}
            </Container>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(UserInfo));
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    min-width: 900px;
    padding: 50px 0 120px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    font-size: 16px;
    font-weight: 300;
    color: #787878;
    @media (max-width: 900px){
        min-width: 320px;
    }
`

const Mask = styled.div`
    position: fixed;
    visibility: ${props => props.isActive ? 'visible' : 'hidden'};
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    transition: all .2s ease-in-out;
    background-color: rgba(0,0,0,.6);
    overflow: hidden;
    /* filter blur 效果設在 Background component中 */
`
const MaskContent = styled.div`
    background-color: #fff;
    padding: 24px 48px;
`
const Footer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`

const Edit = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 0 5px;
    ${({ large }) => large ? 'margin: 0 16px;' : ''}
    margin: 0 8px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: .8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
`

const Error = styled.div`
    margin-bottom: 24px;
    color: #de0606;
`

const SubTitle = styled.div`
    padding-top : 8px;
`
const CancelButton = styled.div`
    padding-top : 8px;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/UserInfo.js